import { render, staticRenderFns } from "./ShowParameters.vue?vue&type=template&id=252b5561&scoped=true"
import script from "./ShowParameters.vue?vue&type=script&lang=js"
export * from "./ShowParameters.vue?vue&type=script&lang=js"
import style0 from "./ShowParameters.vue?vue&type=style&index=0&id=252b5561&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252b5561",
  null
  
)

export default component.exports